// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HmPPPlISfMzPG5Mu1aHN{display:inline-block}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/EnterNumberCommon/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA","sourcesContent":[".description {\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `HmPPPlISfMzPG5Mu1aHN`
};
export default ___CSS_LOADER_EXPORT___;
